import { cn } from "@/lib/utils";

function Loading({ className}: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div className={cn(className, "flex h-full w-full items-center justify-center")}>
            Loading
        </div>
    );
}

export { Loading };